import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import Color from "color";
export var Gradient = /*#__PURE__*/function () {
  function Gradient(config, radial, degrees) {
    _classCallCheck(this, Gradient);

    this.type = radial ? "radial" : "linear";
    this.length = config.length;
    this.gradient = this._setGradient(config);
    this.degrees = radial ? null : parseInt(degrees ? degrees : 180);
  }

  _createClass(Gradient, [{
    key: "grad",
    value: function grad() {
      var cssArr = this.gradient.map(function (gradient) {
        var color = gradient[0];
        var _stop = gradient[1];
        var rgb = color.rgb().string().split("");
        rgb.splice(rgb.length - 1, 0, ", " + color.valpha);
        rgb.splice(3, 0, "a");
        return rgb.join("") + " " + _stop + "%";
      });
      var cssString = cssArr.join(", ");
      return "background: ".concat(this.gradient[0][0].rgb().string(), ";\nbackground: ").concat(this.type, "-gradient(").concat(this.degrees, "deg, ").concat(cssString, ");\n          ");
    }
  }, {
    key: "_getStop",
    value: function _getStop(stop_, index) {
      if (stop_ || stop_ === 0) {
        return parseInt(stop_);
      }

      if (index === 0) {
        return 0;
      }

      if (index === this.length - 1) {
        return 100;
      }

      return index / (this.length - 1) * 100;
    }
  }, {
    key: "_setGradient",
    value: function _setGradient(config) {
      var _this = this;

      var colors = [];

      if (!Array.isArray(config)) {
        return undefined;
      } else {
        var first = config[0];

        if (!Array.isArray(first)) {
          return undefined;
        } else {
          var firstColor = first[0];

          if (typeof firstColor === "string") {
            config.forEach(function (color, i) {
              colors.push([new Color(color[0]), _this._getStop(color[1], i)]);
            });
          } else {
            if (typeof color !== "object") {
              return undefined;
            }

            config.forEach(function (color, i) {
              colors.push([color[0], _this._getStop(color[1], i)]);
            });
          }

          return colors;
        }
      }
    }
  }]);

  return Gradient;
}();